import React from 'react';

import { uniq, isObject } from 'utils/ObjectUtils';

/**
 * @param {string} chunks
 * @returns {React.ReactNode}
 */
export const b = (chunks: any) => <span className="font-weight-bold">{chunks}</span>;

export const i = (chunks: any) => <span className="font-italic">{chunks}</span>;

/**
 * Check if value is a messageDescriptor
 * @param value {any}
 * @returns {boolean}
 */
export const isMessageDescriptor = (value: any) => Boolean(isObject(value) && value.id && value.defaultMessage);

/**
 * @param {React.AnchorHTMLAttributes<HTMLAnchorElement> & { 'data-testid'?: string }} props
 * @returns {(chunks: React.ReactNode) => React.ReactNode}
 */
export const getHyperlink = (props: any) => (chunks: any) => <a {...props}>{chunks}</a>;

/*
 * Transform fetched translations payload to array of Label
 * @param translations {Record<string, Record<string, string>>}
 * @returns {Array<import('modules/global/typing/common/Label').Label>}
 */
export const translationsToLabels = (translations: any = {}) => {
  const languages = Object.keys(translations);
  const keys = uniq(Object.values(translations).flatMap((data: any) => Object.keys(data)));
  return keys.map((key: any) => languages.reduce((acc: any, lang: any) => ({ ...acc, [lang]: translations[lang][key] }), {}));
};
